export default function ExploreWholeCollectionIcon({
  strokeColor = 'currentColor',
  strokeWidth = 2,
  width = 20,
  height = 20
}: {
  strokeColor?: string;
  strokeWidth?: number;
  width?: number;
  height?: number;
}) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      className='mr-2'
      width={width}
      height={height}
      fill='none'
      viewBox='0 0 24 24'
      stroke={strokeColor}
    >
      <path
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth={strokeWidth}
        d='M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10'
      />
    </svg>
  );
}
